import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop.tsx";
import Index from "./pages/Index.tsx";

const Services = lazy(() => import("./pages/Services.tsx"));
const About = lazy(() => import("./pages/About.tsx"));
const CaseStudies = lazy(() => import("./pages/CaseStudies.tsx"));
const Blog = lazy(() => import("./pages/Blog.tsx"));
const BlogPost = lazy(() => import("./pages/BlogPost.tsx"));
const Contact = lazy(() => import("./pages/Contact.tsx"));
const OfstedReports = lazy(() => import("./pages/OfstedReports.tsx"));
const DiagnosticForm = lazy(() => import("./pages/DiagnosticForm.tsx"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe.tsx"));
const InclusionCPD = lazy(() => import("./pages/InclusionCPD.tsx"));
const AIForBusiness = lazy(() => import("./pages/AIForBusiness.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/index" element={<Navigate to="/" replace />} />
            <Route path="/index.html" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/ofsted-reports" element={<OfstedReports />} />
            <Route path="/diagnostic" element={<DiagnosticForm />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/inclusion-cpd" element={<InclusionCPD />} />
            <Route path="/ai-for-business" element={<AIForBusiness />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
